var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"error-container"},[_c('alert-circle-icon',{staticClass:"spacing"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.translatedError))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }